import { Component } from "react";
import DeleteIconFill from "../common_icon/DeleteIconFill";
import EditIcon from "../common_icon/EditIcon";
import {
  polygon_units,
  line_units,
} from "../../App/validation/geometry_to_area_or_length";
import { connect } from "react-redux";

class Header extends Component {
  state = {
    hover: false,
  };

  toggleHover = (value) => {
    this.setState({ hover: value });
  };

  render() {
    const username = this.props.auth.user?.name?.trim() || "";
    const domain = window.location.host;
    const { type, unit } = this.props.column;
    let unit_dimension = "";
    if (type === "calculate_dimension" && unit) {
      unit_dimension = ` (${
        polygon_units?.concat(line_units)?.find((row) => row?.key === unit)
          ?.symbol
      })`;
    }

    const restrictedDsdaAccess = [
      "localhost:3003",
      "dsdajakarta.mapid.io",
      "dsdajakarta-alpha.mapid.io",
      "dsdajakarta-beta.mapid.io",
    ].includes(domain) &&
    !["dsdajakarta","pusdatin_SDA"].includes(username)

    return (
      <section
        title={this.props.column.name}
        className="header_table center_perfect"
        style={{
          display: "flex",
          justifyContent: "flex-start",
          alignItems: "center",
          width: "500px",
        }}
        onMouseEnter={() => {
          !restrictedDsdaAccess && this.toggleHover(true);
        }}
        onMouseLeave={() => {
          !restrictedDsdaAccess && this.toggleHover(false);
        }}
      >
        {this.state.hover && (
          <div
            className="center_perfect"
            style={{
              width: 50,
              // backgroundColor: "#808080",
              paddingTop: 3,
              paddingBottom: 3,
              paddingLeft: 5,
              paddingRight: 5,
              borderRadius: 10,
            }}
          >
            <div className="flex gap_5">
              {restrictedDsdaAccess ? (
                <></>
              ) : (
                <>
                  <div className="center_perfect">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        this.props.toggleDeleteField(this.props.params);
                      }}
                      id="icon_delete"
                      style={{
                        fill: "#cb4747",
                        border: "1px solid #ffffff",
                        borderRadius: "50%",
                        background: "#ffffff",
                        height: "22px",
                        width: "22px",
                      }}
                      className="center_perfect"
                    >
                      <DeleteIconFill width={20} height={20} />
                    </button>
                  </div>
                  <div className="center_perfect">
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        this.props.toggleEditField(this.props.params);
                      }}
                      className="center_perfect"
                    >
                      <EditIcon width={22} height={22} />
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        )}

        <table className="">
          <tbody>
            <tr>
              <td>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    marginLeft: 5,
                    height: "20px",
                  }}
                >
                  <strong className="truncate">
                    {this.props.column.name}
                    {unit_dimension}
                  </strong>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                    marginLeft: 5,
                    height: "20px",
                  }}
                >
                  <p className="truncate">
                    {this.props.column.type.replaceAll("_", " ")}
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        {/* <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "flex-start",
            alignItems: "center",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
            marginLeft: 5,
            height: "20px",
          }}
        >
          <strong className="truncate">{this.props.column.name}</strong>
        </div> */}
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, {})(Header);
